import { atom } from 'jotai';

export const isPendingRequestsViewOpenState = atom<boolean>(false);
